// extracted by mini-css-extract-plugin
module.exports = {"UserProfile":"UserProfile_UserProfile__1RgTP"};